import providerFullcont from "./provider-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const providerDt = require('./provider-dt')
const providerMenu = require('./provider-menu')
const handler = require('./provider-fullcont-handler')
const extrainfo = require('./provider-fullcont-extrainfo')
const { formCopy } = require('./provider-fullcont-form')
const { form } = require('./provider-fullcont-form')
const { providerMT } = require('./provider-fullcont-multitable')
const providerEmailTracking = require('./provider-email-tracking')
const dtHandler = require('../../../../../components/dt/dt-handler')
const navmenu = require('../../../../../components/navmenu/navmenu')

const { generateImage } = require('../../../../../components/avatar/avatar-generator')

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(

            'provider', //database table name****
            'provider', //dest entity on js
            'provider-fullcont',
            providerFullcont, form, formCopy, providerMT,
            editDialog, deleteDialog, dtCall, htmlFc)

      handler.initDataFc(htmlFc)
      HTMLwasSelected = true
}/**/


export function start(detail) {

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/


const obj = {

      addOne: { start: (detail) => { addOne(detail, htmlFc) } },
      cancelEdit: { start: (detail) => { fullcontEntity.cancelEdit(detail, htmlFc) } },
      deleteEntity: { start: (detail) => { fullcontEntity.deleteEntity(detail, htmlFc) } },
      deleteFromDialog: { start: (detail) => { deleteFromDialog(detail, htmlFc) } },
      discard: { start: (detail) => { fullcontHandler.discard(detail, htmlFc) } },
      fullcontOptions: { start: (detail) => { providerMenu.start(detail, 'htmlDt', htmlFc) } },
      hide: { start: (detail) => { fullcontEntity.hide(detail, htmlFc), extrainfo.clean(htmlFc) } },
      prepareAdd: { start: (detail) => { prepareAdd(detail, htmlFc) } },
      prepareEdit: { start: (detail) => { prepareEdit(detail, htmlFc) } },
      saveFromDialog: { start: (detail) => { saveFromDialog(detail, htmlFc) } },
      selectOne: { start: (detail) => { fullcontEntity.selectOne(detail, htmlFc, processSelectOne) } },
      selectOneNoCheck: { start: (detail) => { fullcontEntity.selectOneNoCheck(detail, htmlFc, processSelectOne) } },
      update: { start: (detail) => { update(detail, htmlFc) } },
      complete_bill_to_ship: { start: (detail) => { handler.complete_bill_to_ship(htmlFc) } },
      checkEmailInput: { start: (detail) => { handler.checkEmailInput(htmlFc) } },
      sendEmailFromButton: { start: (detail) => { handler.sendEmailFromButton(htmlFc) } },
      printBehaivor: { start: (detail) => { extrainfo.printBehaivor(detail, htmlFc) } },
      printReport: { start: (detail) => { handler.printReport(detail, htmlFc) } },

}/**/

function processSelectOne(data, result) {
      const cont = htmlFc.fullcontHTML;
      const id = cont.getAttribute('data-dbid') ?? null;

      setCodeAppBar(data)

      providerEmailTracking.render(result, htmlFc.fullcontHTML)
      extrainfo.fill(result.extrainfo, htmlFc)
      handler.syncEmailAccessState(htmlFc);
      handler.initChatsFc(data.chats)

      navmenu.start({
            act: 'renderNavMenu',
            container: '#provider-navmenu-container',
            items: [
                  {
                        label: 'Acc. Payable',
                        icon: 'payable',
                        dest: 'provider',
                        action: 'printReport',
                        extraData: { entity: 'provider', elem: 'fullcont', reportName: 'account-payable-one' }
                  },
                  {
                        label: 'Profit Report',
                        icon: 'profit',
                        dest: 'provider',
                        action: 'printReport',
                        extraData: { entity: 'provider', elem: 'fullcont', reportName: 'account-all-profit' }
                  },
            ]
      })
}

function setCodeAppBar(data) {
      const cont = htmlFc.fullcontHTML
      const span = cont.querySelectorAll('.provider-code')
      if (!span) return;
      span.forEach(i => {
            i.innerText = `${data.code}`   
      });
}


function processEmail(data, result, sendAccessEmail = true) {
      if (sendAccessEmail) {
            data.new_user = true;
            handler.sendResetEmail(data, htmlFc);
      }

      handler.syncEmailAccessState(htmlFc);

}

function prepareEdit(detail, htmlFc) {

      handler.syncEmailAccessState(htmlFc);
      fullcontHandler.prepareEdit(detail, htmlFc)
}

async function saveFromDialog(detail, htmlFc) {
      if (!await handler.checkEmailInput(htmlFc, true)) { return; }

      const sendAccessEmail = handler.shouldSendAccessEmail(htmlFc);
      fullcontEntity.saveFromDialog(detail, htmlFc, (data, result) => {
            processEmail(data, result, sendAccessEmail);
      });
}



function prepareAdd(detail) {
      extrainfo.clean(htmlFc)
      providerEmailTracking.clean(htmlFc.fullcontHTML)
      fullcontEntity.prepareAdd(detail, htmlFc)
      handler.syncEmailAccessState(htmlFc)
}


//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'provider' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'provider', id: "deleteElem", entity: 'provider', dbid: detail.dbid })
}

function dtCall(act, result) {
      providerDt.start({ act: act, row: result })
}


async function addOne(detail, htmlFc) {

      if (await handler.checkEmailInput(htmlFc, true)) {
            const sendAccessEmail = handler.shouldSendAccessEmail(htmlFc);
            fullcontEntity.addOne(detail, htmlFc, (data, result) => {
                  processEmail(data, result, sendAccessEmail);
            });

            generateImage(detail, htmlFc)

      }

}

async function update(detail, htmlFc) {

      if (await handler.checkEmailInput(htmlFc, true)) {
            const sendAccessEmail = handler.shouldSendAccessEmail(htmlFc);
            fullcontEntity.update(detail, htmlFc, (data, result) => {
                  processEmail(data, result, sendAccessEmail);
            });
      }

}

function deleteFromDialog(detail, htmlFc) {

      fullcontEntity.deleteFromDialog(detail, htmlFc)
      setTimeout(() => {
            providerDt.start({ "dest": "provider", "elem": "dt", "act": "select", "entity": "provider" })
      }, 900)

}
